import { runBotBatch } from '../../../../../shared/services/bot-bulk-actions';

import { Component, output, signal } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { AdminService } from '@shared-angular/services/admin.service';
import { HintComponent } from '@shared-angular/components/hint/hint.component';
import { LanguageService } from '@shared-angular/services/language.service';
import { ChatbotConfig } from '@shared/index';
import dayjs from 'dayjs';
import { BsModalService } from 'ngx-bootstrap/modal';
import { MenuItem } from 'primeng/api';
import { Button, ButtonModule } from "primeng/button";
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { Popover } from "primeng/popover";
import { TableModule } from "primeng/table";
import { TagModule } from "primeng/tag";
import { ProjectPagehearderComponent } from "src/app/project-pagehearder/project-pagehearder.component";
import { AdminPositionBubbleComponent } from "src/app/shared/components/ai-bot/utils/admin-position-bubble/admin-position-bubble.component";
import { BotIconComponent } from "src/app/shared/components/bot-icon/bot-icon.component";
import { BotPreviewService } from 'src/app/shared/services/bot-preview.service';
import { BotService } from 'src/app/shared/services/bot.service';
import { BulkAction, BulkActionBarComponent } from 'src/app/shared/components/bulk-action-bar/bulk-action-bar.component';
import { MoveBotToProjectComponent } from '../projects-page/project-bots-tab/move-bot-to-project/move-bot-to-project.component';

@Component({
  imports: [RouterLink, ProjectPagehearderComponent,
    InputTextModule,
    InputIconModule,
    IconFieldModule,
    TableModule,
    AdminPositionBubbleComponent,
    HintComponent,
    Popover,
    ButtonModule,
    BotIconComponent,
    TagModule,
    BulkActionBarComponent
  ],
  templateUrl: './archive-page.component.html',
  styleUrl: './archive-page.component.scss'
})
export class ArchivePageComponent {
  public get bulkActions(): BulkAction[] {
    return [
      {
        id: 'restore',
        label: $localize`:@@restore:Wiederherstellen`,
        icon: 'ri-arrow-go-back-line',
        disabled: this.bulkBusy,
        command: () => this.runBulk('restore')
      }
    ];
  }

  public readonly reloadTrigger = output();
  private readonly _selectedBots = signal<ChatbotConfig[]>([]);
  public get selectedBots(): ChatbotConfig[] { return this._selectedBots(); }
  public set selectedBots(value: ChatbotConfig[]) { this._selectedBots.set(value); }
  private readonly _bulkBusy = signal(false);
  public get bulkBusy(): boolean { return this._bulkBusy(); }
  public set bulkBusy(value: boolean) { this._bulkBusy.set(value); }
  private readonly _bulkFailedNames = signal('');
  public get bulkFailedNames(): string { return this._bulkFailedNames(); }
  public set bulkFailedNames(value: string) { this._bulkFailedNames.set(value); }
  private readonly _bots = signal<ChatbotConfig[]>([]);
  public get bots(): ChatbotConfig[] { return this._bots(); }
  public set bots(value: ChatbotConfig[]) { this._bots.set(value); }
  public dayjs = dayjs;
  public contextMenu: (MenuItem & { command: () => void })[] = [];
  private activePop: Popover | null = null;

  constructor(
    public aRoute: ActivatedRoute,
    private langService: LanguageService,
    private botPreview: BotPreviewService,
    private modalService: BsModalService,
    public botService: BotService,
    public adminService: AdminService) {
    this.aRoute.data.subscribe((data) => {
      this.bots = (data as unknown as { bots: ChatbotConfig[] }).bots;
    });
  }


  public async runBulk(_action: 'restore', bots = [...this.selectedBots]): Promise<void> {
    if (this.bulkBusy || !bots.length) return;
    this.bulkBusy = true;
    this.bulkFailedNames = '';
    try {
      const result = await runBotBatch(bots, id => this.adminService.unarchiveBot(id));
      this.bots = this.bots.filter(bot => !result.succeeded.has(bot._id));
      this.selectedBots = result.failed;
      this.bulkFailedNames = result.failed.map(bot => bot.name).join(', ');
    } finally {
      this.bulkBusy = false;
    }
  }

  public async reloadBots() {
    this.bots = await this.adminService.loadArchiveBots();
    this.selectedBots = this.selectedBots.filter(selected => this.bots.some(bot => bot._id === selected._id));
  }

  public async deleteBot(id: string) {
    await this.adminService.deleteBot(id);
    this.bots = this.bots.filter(bot => bot._id !== id);
    this.selectedBots = this.selectedBots.filter(bot => bot._id !== id);
  }
  public openMenu(event: MouseEvent, popover: Popover, bot: ChatbotConfig, button: Button) {
    if (this.activePop && this.activePop !== popover) {
      this.activePop.hide();
    }
    this.contextMenu = this.getMenuItems(bot);
    popover.toggle(event, button.el.nativeElement);
    this.activePop = popover;
  }

  private getMenuItems(bot: ChatbotConfig) {
    const menu: (MenuItem & { command: () => void })[] = [];
    menu.push({
      label: $localize`:@@move-project:Verschieben`,
      icon: 'ri ri-folder-transfer-line',
      command: () => {
        this.moveBotToProject(bot);
      }
    });
    menu.push({
      label: $localize`:@@restore:Wiederherstellen`,
      icon: 'ri ri-arrow-go-back-line',
      command: async () => {
        await this.unarchiveBot(bot._id);
      }
    });
    return menu;
  }
  public openBot(bot: ChatbotConfig) {
    void this.botPreview.open(bot._id, "/" + this.langService.getLanguage() + '/bot/' + bot._id);
  }

  public moveBotToProject(bot: ChatbotConfig) {
    const projectId = bot.projectId;
    this.modalService.show(MoveBotToProjectComponent, { initialState: { bot, projectId: projectId ?? "-" } });
  }
  public async unarchiveBot(id: string) {
    await this.adminService.unarchiveBot(id);
    this.bots = this.bots.filter(bot => bot._id !== id);
    this.selectedBots = this.selectedBots.filter(bot => bot._id !== id);
    this.reloadTrigger.emit();
  }
}
